
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import CatalogListGrid from "../../../common/catalog/CatalogListGrid";
import { catalogPageParams } from "../../../common/catalog/catalogPageSize";
import Paginator from "../../../common/paginator/Paginator";
import Skeleton from "../../../common/loading/Skeleton";
import Publication from "../common/Publication";

export default function MyPublicationSection({ isDesktop }) {
    const [publications, setPublications] = useState([]);
    const [page, setPage] = useState(1);
    const [maxPageNum, setMaxPageNum] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        fetchPublications();
    }, []);

    useEffect(() => {
        fetchPublications();
    }, [page]);

    function fetchPublications() {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        api.publicationListMine({
            token: LoginHelper.getToken(),
            ...catalogPageParams(page),
        }).then((result) => {
            setPublications(result['publications']);
            setMaxPageNum(result['max_page']);
            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);
            if (err && err.data) {
                setErrorMessage(err.data.message);
            }
        })
    }

    return (
        <div>
            <div className="font-Vazir-700 text-[16px] text-[#666666] mb-2">مقالات من</div>
            {isLoading && publications.length === 0 && <Skeleton variant="grid" type="publication" count={4} />}
            <CatalogListGrid isDesktop={isDesktop}>
                {publications && !isLoading && (
                    <>
                        {publications.length >= 1 ? (
                            <>
                                {publications.map(publication => (
                                    <Publication key={publication.id} publication={publication} />
                                ))}
                            </>
                        ) : (
                            <div className="text-[#666666] font-Vazir-400 text-[14px]">
                                شما هیچ مقاله‌ای ندارید.
                            </div>
                        )}
                    </>
                )}
            </CatalogListGrid>
            {publications.length >= 1 && maxPageNum >= 2 && (
                <>
                    <div className="spacer p-[20px]"></div>
                    <div className="flex flex-row justify-center">
                        <Paginator currentPage={page} maxPageNum={maxPageNum} isLoading={isLoading} onChange={(newPage) => { setPage(newPage) }} />
                    </div>
                </>
            )}
            {errorMessage && (
                <div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
            )}
        </div>
    )
}
